/**
 * Get the YYYY-MM-DD representation of a javascript date object
 * @param  Date
 * @return string
 */
export const getYYYYMMDD = date => {
	const month = (date.getMonth() + 1).toString();
	const day = date.getDate().toString();
      const monthString = month.length < 2 ? `0${month}` : month;
      const dayString = day.length < 2 ? `0${day}` : day;
	return `${date.getFullYear()}-${monthString}-${dayString}`;
}

/**
 * Get javascript date from YYYY-MM-DD string
 * returns current date if error parsing string
 * @param  String
 * @return Date
 */
export const fromYYYYMMDD = dateString => {
    if (typeof dateString !== 'string') {
        return new Date();
    }
    const year = dateString.substring(0, 4);
    const month = dateString.substring(5, 7);
    const day = dateString.substring(8, 10);
    const date = new Date(+year, +month - 1, +day);
    return isNaN(date.getTime()) ? new Date() : date;
}

/**
 * Get H:i:s time string from date object
 * @param  Date
 * @return string
 */
export const getHoursMinutesSeconds = date => {
    return date.toISOString().slice(0,19).split('T')[1];
}

/**
 * Get Y-m-d H:i:s datetime string from date object
 * @param  Date
 * @return {string
 */
export const getDateTimeString = date => {
    return `${getYYYYMMDD(date)} ${getHoursMinutesSeconds(date)}`;
}
/**
 * Create a copy of the provided date
 * @param  Date
 * @return Date
 */
export const cloneDate = date => {
    return new Date(date.getTime());
}

/**
 * Is the provided a valid timezone string that can be used with the Intl API
 * 
 * @param  string
 * @return bool
 */
export const isValidTimezoneString = tz => {
    const aDate = new Date();
    try {
       if (typeof aDate.toLocaleString([], {timezone: tz}) === "string") {
           return true;
       }
    } catch(err) {
        return false;
    }
}

/**
 * Add/subtract days to provided date
 * @param  Date
 * @param  number
 * @return Date
 */
export const applyDaysToDate = (date, days) => {
    const newDate = cloneDate(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
}

/**
 * Get the last day of week prior to the provided date. Example: "The previous tuesday before..."
 * @param  Date         referenceDate
 * @param  int | string day - the numeric representation of the day of week, or the case insensitive day string
 *                            ex. getPreviousDayOfWeekFromDate(date, 2) === getPreviousDayOfWeekFromDate(date, 'Tuesday')
 * @return date
 */
export const getPreviousDayOfWeekFromDate = (referenceDate, day) => {
    const map = {
        '0': 0,
        '1': 1,
        '2': 2,
        '3': 3,
        '4': 4,
        '5': 5,
        '6': 6,
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6,
    };

    const requestedDayString = String(day).toLowerCase();

    // if invalid day arg provided, just return the provided reference date
    if (Object.keys(map).indexOf(requestedDayString) === -1) {
        return referenceDate;
    }

    const numericDayOfWeek = map[requestedDayString];
    const currentDay = referenceDate.getDay();
    const diff = currentDay - numericDayOfWeek;
    let toSubtract = 7;
    if (currentDay !== numericDayOfWeek) {
        toSubtract = currentDay > numericDayOfWeek ? diff : diff + 7;
    }
    return applyDaysToDate(cloneDate(referenceDate), (toSubtract * -1));

}

/**
 * Returns a date object from the provided ISO date string.
 * @param  string
 * @return Date
 */
export function ISOStringToDate(string) {
    const parts = string.split(/\D/);
    return new Date (parts[0], parts[1]-1, parts[2], parts[3], parts[4], parts[5]);
}

/**
 * Handle creating date object from date string
 * @param  string
 * @return Date
 */
export const stringToDate = string => {
    let result = new Date(string);
    if (isNaN(result.getTime())) {
        // handle safari
        result = new Date(string.replace(/-/g, '/'));
    }
    return result;
}
